export default "__VITE_ASSET__DyQqMaLM__"